export const calculatorsData = [
  {
    id: 1,
    calculatorName: "Personal Loan Refinance Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/personal-loan-refinancing-1738391113368.webp",
    link: "/calculators/refinancing-calculators/refinancing-personal-loan-calculator",
  },
  {
    id: 2,
    calculatorName: "Car Loan Refinancing Calculator",
    image:
      "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/refinance-auto-loan-1738390834573.webp",
    link: "/calculators/refinancing-calculators/refinancing-car-loan-calculator",
  },
];
